import { HandlerEvent } from 'post-robot';
import { pushErrors, pushUnbind } from 'common/gamp';
import { resetUserProfile } from 'communicator/store';
import { getAccessToken, getVIntentId } from 'communicator/store/selectors';
import { markEnd, markStart } from 'communicator/utils/instrumentation';
import { dumpLongTasks } from 'communicator/utils/instrumentation-long-task';
import unbind from 'communicator/utils/unbind';
import {
  UnbindAppInstanceData,
  UnbindAppInstanceResponse
} from 'types/visa-sdk/unbind-app-instance';

export default async function unbindAppInstance(
  event: HandlerEvent<UnbindAppInstanceData>
): Promise<UnbindAppInstanceResponse> {
  try {
    dumpLongTasks();
    markStart('UNBIND');

    const data = event.data;
    const accessToken = getAccessToken();

    const vIntentId = getVIntentId() ?? null;

    await unbind({
      accessToken: accessToken?.token,
      idTokens: data.idTokens
    });

    pushUnbind();
    resetUserProfile();

    markEnd('UNBIND', { doFlush: true });

    return {
      srcCorrelationId: vIntentId
    };
  } catch (err: unknown) {
    // START GENAI@GHCOPILOT
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const sErr = JSON.stringify(err) !== undefined ? JSON.stringify(err) : 'Unknown error';

    markEnd('UNBIND', { doFlush: true, failure: true, reason: sErr });
    pushErrors('Unbind', err);

    return {
      srcCorrelationId: null
    };
    // END GENAI@GHCOPILOT
  }
}
